import React from 'react';

import TabLogo from './TabLogo';
import { SongType } from '../../types';

const GuitarTabLink = ({ song }: GuitarTabLinkTypes) => {
	const { link } = song;

	if (!link) return null;

	return (
		<a
			className="guitar-tab-link"
			href={link}
			rel="noreferrer"
			style={linkStyle}
			target="_blank"
			title="Go to Guitar Tabs"
		>
			<TabLogo link={link} style={guitarLink} />
		</a>
	);
};

// Runs the full height of the row (a flex child of the row, which stretches) so
// the whole right edge is tappable, with the logo centred inside.
const linkStyle: React.CSSProperties = {
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	padding: '0 15px',
};

const guitarLink = {
	width: 40,
};

type GuitarTabLinkTypes = {
	song: SongType;
};

export default GuitarTabLink;
